import { z } from "zod";

export const sitecardsData = z.object({
  image: z.optional(z.string().url()),
  pdf: z.optional(z.string().url()),
  uniquePlacement: z.optional(z.boolean()),
});
